<template lang="html">
    <div>
        Criar Album
        <album-form ref="albumForm" v-model="album" @change="albumFormChange($event)" />

        <!-- Buttons -->
        <v-container>
          <div class="text-xs-right">
            <v-btn color="" large>Cancelar</v-btn>
            <v-btn color="success" :disabled="!isAlbumValid" large @click="clickCreate()">Guardar</v-btn>
          </div>
        </v-container>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import albumForm from '@/components/Album/albumForm'
export default {
  data: function () {
    return {
      isAlbumValid: false,
      album: {
        title: null,
        author: null,
        release_date: null,
        serial: null,
        spotify_widget: null,
        cover_image: null,
        descriptions:[],
        platforms:[],
      }
    }
  },
  methods: {
    ...mapActions([
      'createAlbum'
    ]),
    clickCreate: function () {
      this.createAlbum(this.album).then(() => {
        this.$router.push({ name: 'AlbumList' })
      })
    },
    albumFormChange: function ($event) {
      this.isAlbumValid = $event.valid
    }
  },
  components:{
    albumForm
  }
}
</script>

<style lang="css" scoped>
</style>
